import { useEffect, useMemo, useState } from 'react';

/**
 * Client-side pagination over a fully-loaded dataset.
 * Returns { page, pageSize, pageCount, pageData, setPage, setPageSize, totalItems }.
 * Resets to page 1 whenever the underlying data length changes.
 */
export const usePagination = (data, initialPageSize = 25) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const totalItems = data?.length || 0;
  const pageCount = Math.max(1, Math.ceil(totalItems / pageSize));

  useEffect(() => {
    if (page > pageCount) setPage(1);
  }, [pageCount, page]);

  const pageData = useMemo(() => {
    if (!data) return [];
    const start = (page - 1) * pageSize;
    return data.slice(start, start + pageSize);
  }, [data, page, pageSize]);

  return {
    page,
    pageSize,
    pageCount,
    pageData,
    setPage,
    setPageSize: (size) => {
      setPageSize(size);
      setPage(1);
    },
    totalItems,
  };
};

export default usePagination;
